import * as durationHelper from '../../helpers/duration-handler';
import * as transitionHelper from '../../helpers/transition-handler';
import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-token';
import { HTTP_GO } from '../../core/http/http-go-token';
import service from '../../services/index';
const state = {
  loading: false,
  title: '',
  nbPerPage: 32,
  medias: {
    videos: [],
    images: [],
  },
  nbVideos: 0,
  page: {
    images: 1,
    videos: 1,
  },
  endReachedMedias: {
    images: false,
    videos: false,
  },
};

const mutations = {
  setTitleMedias(state, title) {
    state.title = title;
  },
  setMedias(state, { type, medias }) {
    state.medias[type] = medias;
  },
  pushMedias(state, { type, medias }) {
    state.medias[type] = state.medias[type].concat(medias);
  },
  resetPageVideos(state, type) {
    state.page[type] = 1;
  },
  setNbTotalVideos(state, nb) {
    state.nbVideos = nb;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  incrementPageMedias(state, type) {
    state.page[type] += 1;
  },
  isEndReachedMedias(state, { type, endReached }) {
    state.endReachedMedias[type] = endReached;
  },
};

const actions = {
  async reloadVideoList({ commit }) {
    let type = 'videos';
    let params = {
      id: '',
      page: state.page[type],
      nbParPage: state.nbPerPage,
      client: localStorage.getItem('client'),
      maxBitrate: true,
    };
    if (state.title) {
      params.searchWord = state.title;
    } else {
      params.searchWord = "";
    }

    commit('incrementPageMedias', type);
    let { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(Routing.generate('api_media_get_media', params))
        .then(function(response) {
          if (response.data.code === 200) {
            if (response.data) {
              resolve(response);
            }
          }
        });
    });
    let datas = data.medias;
    // commit('pushVideos',datas);
    commit('pushMedias', { type: type, medias: datas });
    commit('setNbTotalVideos', data.nombre_total);
    if (datas.length < state.nbPerPage) {
      commit('isEndReachedMedias', { type: type, endReached: true });
    }
    commit('setLoading', false);
  },
  async reloadImageList({ commit }) {
    let type = 'images';
    let params = {
      offset: (state.page[type] - 1) * state.nbPerPage,
      count: state.nbPerPage - 1,
      // client: localStorage.getItem('client'),
    };
    if (state.title) {
      params.q = state.title;
    }
    commit('incrementPageMedias', type);

    let data = await service.getAllPhotos(params);
    // commit('setNbTotalVideos', data.nombre_total);
    //commit('pushImages', data.data);
    commit('pushMedias', { type: type, medias: data.data });
    // commit('setLoading', false);

    if (data.data.length < state.nbPerPage - 1) {
      commit('isEndReachedMedias', { type: type, endReached: true });
    }
    commit('setLoading', false);
  },
  setTitleMedias: ({ state, commit }, title) => commit('setTitleMedias', title),
  resetPageVideos({ state, commit }, type) {
    commit('resetPageVideos', type);
  },
  setMedias: ({ state, commit }, data) => commit('setMedias', data),
  setEndReachedMedias: ({ state, commit }, data) => commit('isEndReachedMedias', data),
};

// getters are functions
const getters = {
  getLoading: state => state.loading,
  getEndReachedMedias: state => type => state.endReachedMedias[type],
  getAllMedias: state => type => state.medias[type],
  //getAllImages: state => type => state.medias[type],
  getNbVideos: state => state.nbVideos,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/medias-data.js